@if (isLoading()) {
  <app-loader/>
} @else if (shareholdersViewModel().shareholderDetails) {
  <app-securityholder-profile
    [showCompanyActions]="showCompanyActions()"
    [pendingButtonState]="shareholdersViewModel().isPendingChangesVisible"
    [securityholder]="shareholdersViewModel().shareholderDetails!"
    (profileViewChange)="setShareholdersDetails(null)"
    (onDataSaved)="onRefreshShareholders()"
    (changeShareholderPartyName)="changeShareholderPartyName.emit($event)"
    (changeShareholderAddress)="changeShareholderAddress.emit($event)"
  />
} @else {
  <div class="card-body p-0">
    <app-grid-client-side
      [rowData]="shareholdersViewModel().shareholders"
      [colDefs]="$any(colDefs())"
      [gridOptions]="gridOptions"
      [suppressRowClickSelection]="true"
      [suppressCellFocus]="true"
      [paginationPageSizeSelector]="true"
      [excelStyles]="excelStyles"
      (gridReady)="onGridReady($event)"
      (select)="onSelectShareholders($event)"
    >
      @if (shareholdersViewModel().isShowPastShareholdersToggleVisible) {
        <div class="grid-controls-middle h-100 d-flex flex-grow-1">
          <label class="d-flex align-items-center gap-2 mb-0">
            <app-toggle-button
              [switched]="shareholdersViewModel().isPastShareholdersVisible"
              (switchBtn)="setIsPastShareholdersVisible($event)"
            />

            <span class="font-size-14">Show Past Shareholders</span>
          </label>
        </div>
      }

      <div class="grid-controls-end">
        <div ngbDropdown>
          <button
            ngbDropdownToggle
            type="button"
            title="Export"
            class="btn btn-secondary btn-icon"
          >
            <i class="icon ic-download-20"></i>
          </button>


          <div ngbDropdownMenu class="common-dropdown-menu">
            <button
              ngbDropdownItem
              type="button"
              (click)="onExportSecurityholders(ExportTypeEnum.EXCEL)"
            >
              Export to xlsx
            </button>

            <button
              ngbDropdownItem
              type="button"
              (click)="onExportSecurityholders(ExportTypeEnum.PDF)"
            >
              Export to pdf
            </button>
          </div>
        </div>
      </div>
    </app-grid-client-side>
  </div>
}
